export class VehicleDocumentDto {
  image: string;
  description: string;
  expirationDate: string;
}
